import Roles from '../pages/roles';

const rolesRoutes = [
  { component: Roles }
];

export default rolesRoutes;
